"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bcmPermissionSettingReducer = exports.bcmPermissionSettingActions = exports.TYPES = void 0;
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'bcmPermissionSetting';

// 初期状態
const INIT_STATE = {
  searchConditions: {
    userNm: '',
    shokuiCd: '',
    kaishaCd: '',
    soshikiCd: '',
    kaishaSoshikiLabel: ''
  },
  searchResult: [],
  bcmKaishaSoshikiList: [],
  refferBcmKaishaSoshikiList: [],
  paging: {
    viewNum: 50,
    currentPage: 0
  },
  showAll: false,
  reload: false,
  isManualScroll: false
};

// アクションタイプ
const TYPES = exports.TYPES = {
  // 検索条件変更
  CHANGE_SEARCH_CONDITION: PREFIX + 'ChangeSearchCondtion',
  // 検索結果一覧設定
  SET_SEARCH_RESULT: PREFIX + 'SetSearchResult',
  // ページ変更
  CHANGE_PAGE: PREFIX + 'ChangePage',
  // １ページの表示件数を変更
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  // 全て表示する
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  // 会社／組織追加
  ADD_KAISHA_SOSHIKI: PREFIX + 'AddKaishaSoshiki',
  // 会社／組織削除
  DELETE_KAISHA_SOSHIKI: PREFIX + 'DeleteKaishaSoshiki',
  // BCP対象事業変更
  CHANGE_BCP_TGT_JIGYO: PREFIX + 'ChangeBcpTgtJigyo',
  // 初期状態にする
  CLEAR: PREFIX + 'Clear'
};

// アクション作成
const bcmPermissionSettingActions = exports.bcmPermissionSettingActions = (0, _reduxActions.createActions)({
  // 検索条件変更
  [TYPES.CHANGE_SEARCH_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 検索結果一覧設定
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0],
      bcmKaishaSoshikiList: arguments.length <= 1 ? undefined : arguments[1],
      refferBcmKaishaSoshikiList: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  // ページ変更
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // １ページの表示件数を変更
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 全て表示する
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 会社／組織追加
  [TYPES.ADD_KAISHA_SOSHIKI]: function () {
    return {
      kaishaCd: arguments.length <= 0 ? undefined : arguments[0],
      shainId: arguments.length <= 1 ? undefined : arguments[1],
      bcmKaishaSoshikiCd: arguments.length <= 2 ? undefined : arguments[2],
      bcmKaishaSoshikiNm: arguments.length <= 3 ? undefined : arguments[3]
    };
  },
  // 会社／組織削除
  [TYPES.DELETE_KAISHA_SOSHIKI]: function () {
    return {
      kaishaCd: arguments.length <= 0 ? undefined : arguments[0],
      shainId: arguments.length <= 1 ? undefined : arguments[1],
      bcmKaishaSoshikiCd: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  // BCP対象事業変更
  [TYPES.CHANGE_BCP_TGT_JIGYO]: function () {
    return {
      kaishaCd: arguments.length <= 0 ? undefined : arguments[0],
      shainId: arguments.length <= 1 ? undefined : arguments[1],
      bcmKaishaSoshikiCd: arguments.length <= 2 ? undefined : arguments[2],
      bcpTgtJigyoCds: arguments.length <= 3 ? undefined : arguments[3],
      bcpTgtJigyoNms: arguments.length <= 4 ? undefined : arguments[4]
    };
  }
},
// 初期状態にする
TYPES.CLEAR);

// アクション
const bcmPermissionSettingReducer = exports.bcmPermissionSettingReducer = (0, _reduxActions.handleActions)({
  // 検索条件変更
  [TYPES.CHANGE_SEARCH_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchConditions: _objectSpread(_objectSpread({}, state.searchConditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  // 検索結果一覧設定
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchResult: action.payload.searchResult,
    bcmKaishaSoshikiList: action.payload.bcmKaishaSoshikiList,
    refferBcmKaishaSoshikiList: action.payload.refferBcmKaishaSoshikiList,
    paging: _objectSpread({}, INIT_STATE.paging),
    reload: false,
    isManualScroll: false
  }),
  // ページ変更
  [TYPES.CHANGE_PAGE]: (state, action) => {
    return _objectSpread(_objectSpread({}, state), {}, {
      paging: _objectSpread(_objectSpread({}, state.paging), {}, {
        currentPage: action.payload.currentPage
      })
    });
  },
  // １ページの表示件数を変更
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: 0,
      viewNum: action.payload.viewNum
    })
  }),
  // 全て表示する
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    let newSearchResult = JSON.parse(JSON.stringify(state.searchResult)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      showAll: action.payload.showAll,
      searchResult: newSearchResult
    });
  },
  // 会社／組織追加
  [TYPES.ADD_KAISHA_SOSHIKI]: (state, action) => {
    let newSearchResult = JSON.parse(JSON.stringify(state.searchResult)).map(userData => {
      if (userData.kaishaCd === action.payload.kaishaCd && userData.shainId === action.payload.shainId) {
        let newAvailableData = {
          bcmKaishaSoshikiCd: action.payload.bcmKaishaSoshikiCd,
          bcmKaishaSoshikiNm: action.payload.bcmKaishaSoshikiNm,
          bcpTgtJigyoCds: [],
          bcpTgtJigyoNms: ''
        };
        userData.updateTarget = true;
        userData.availableList.push(newAvailableData);
      }
      return userData;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      reload: false,
      searchResult: newSearchResult,
      isManualScroll: true
    });
  },
  // 会社／組織削除
  [TYPES.DELETE_KAISHA_SOSHIKI]: (state, action) => {
    let newSearchResult = JSON.parse(JSON.stringify(state.searchResult)).map(userData => {
      if (userData.kaishaCd === action.payload.kaishaCd && userData.shainId === action.payload.shainId) {
        let newAvailableList = userData.availableList.filter(availableData => {
          return availableData.bcmKaishaSoshikiCd !== action.payload.bcmKaishaSoshikiCd;
        });
        userData.updateTarget = true;
        userData.availableList = newAvailableList;
      }
      return userData;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      reload: false,
      searchResult: newSearchResult,
      isManualScroll: true
    });
  },
  // BCP対象事業変更
  [TYPES.CHANGE_BCP_TGT_JIGYO]: (state, action) => {
    let newSearchResult = JSON.parse(JSON.stringify(state.searchResult)).map(userData => {
      if (userData.kaishaCd === action.payload.kaishaCd && userData.shainId === action.payload.shainId) {
        let newAvailableList = userData.availableList.map(availableData => {
          if (availableData.bcmKaishaSoshikiCd === action.payload.bcmKaishaSoshikiCd) {
            availableData.bcpTgtJigyoCds = action.payload.bcpTgtJigyoCds;
            availableData.bcpTgtJigyoNms = action.payload.bcpTgtJigyoNms;
          }
          return availableData;
        });
        userData.updateTarget = true;
        userData.availableList = newAvailableList;
      }
      return userData;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      reload: false,
      searchResult: newSearchResult,
      isManualScroll: true
    });
  },
  // 初期状態にする
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);